import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconNewspaper: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"newspaper, News, paper"} maskId="square-filled-radius-0-stroke-1-IconNewspaper"><path d="M7 8V12H12V8H7Z" fill="currentColor"/><path fillRule="evenodd" clipRule="evenodd" d="M2 3H17V11.5H22V18C22 19.6569 20.6569 21 19 21H5C3.34315 21 2 19.6569 2 18V3ZM19 20C20.1046 20 21 19.1046 21 18V12.5H17V18C17 19.1046 17.8954 20 19 20ZM6 16H13V15H6V16ZM6 7H13V13H6V7Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconNewspaper;
